<template>
    <v-col :cols="wide ? 0 : 12">
        <DropPad :disabled="!editable"
            :height="wide ? (list && list.length ? '100%' : '200px') : (list && list.length ? 'auto' : '60px')"
            width="100%" align="stratch" justify="start" multiple @fileDrop="handleFileDrop"
            @click="editable ? openDialog() : undefined">
            <!-- @click="openPickerOnClick ? clickFileInput() : $emit('click')" -->
            <FileSectionHeader :value="collapsed" :text="title" :count="list && list.length" :loading="loading"
                class="mt-2">
                <template v-slot:divider>
                    <slot name="divider"></slot>
                </template>
            </FileSectionHeader>
            <div v-if="!collapsed && list && list.length" class="d-flex flex-wrap"
                style="pointer-events: auto !important;">
                <File v-for="(file, index) in list.slice(0, rendererXFiles)" :key="title + '-' + index" :file="file"
                    :grid="grid" :selected="isSelected(file)" :selectable="true" :entityName="entityName"
                    :defaultEmailTemplate="defaultEmailTemplate"
                    @ToggleSelect="({ file, selected }) => $emit('ToggleSelect', { file, selected, entityName })"
                    @Delete="file => $emit('Delete', file)"
                    @TogglePublishToCustomer="file => $emit('TogglePublishToCustomer', file)">
                </File>
                <div v-if="list.length > rendererXFiles">
                    <v-btn text color="primary" @click.stop="rendererXFiles += 100">
                        {{ $t('servicesystem.common_objects.commonterms.show_more') }}
                    </v-btn>
                </div>
            </div>

            <template v-if="!loading && editable">
                <v-spacer v-if="wide"></v-spacer>
                <div class="d-flex align-center justify-center pb-2">
                    <v-btn text color="success" style="text-transform: none; height: 24px">
                        <v-icon size="16">mdi-plus</v-icon>
                        {{ $t('servicesystem.common_objects.document.upload') }}
                    </v-btn>
                    <small style="opacity: 0.7; padding-top: 2px;">
                        ({{ $t('servicesystem.common_objects.document.click_or_drop_file') }})
                    </small>
                </div>
            </template>
        </DropPad>
        <v-file-input v-show="false" v-model="uploadFile" ref="fileinput" color="primary" multiple="multiple">
            <template v-slot:selection="{ index, text }">
                <v-chip v-if="index < 2" color="primary" dark label>
                    {{ text }}
                </v-chip>
            </template>
        </v-file-input>

        <UploadDialog :externaltrigger="dialogTrigger" :limitName="limitName" @ExternalContent="uploadExternalContent"
            @PickFiles="clickFileInput()">
        </UploadDialog>

    </v-col>
</template>


<script>
import UploadDialog from "@/components/Dialogs/UploadDialog2.vue";
import DropPad from "@/components/SingleUse/DropPad.vue";
import File from "@/views/pim/documents/File.vue";
import FileSectionHeader from "@/views/pim/documents/FileSectionHeader.vue";

export default {
    name: 'FolderGrouping',
    props: {
        title: String,
        list: Array,
        collapsed: Boolean,
        grid: Boolean,
        wide: Boolean,
        loading: Boolean,
        //filedrop props
        editable: Boolean,
        openPickerOnClick: {
            type: Boolean,
            default: false,
        },
        limitName: Boolean,

        selectedKeys: { type: Set, default: null }, // Set of "entityName:typeId:id"
        entityName: { type: String, required: true },
        defaultEmailTemplate: { type: Object, default: null },
    },
    components: {
        FileSectionHeader,
        File,
        DropPad,
        UploadDialog,
    },

    data() {
        return {
            uploadFile: null,
            dialogTrigger: 1,
            rendererXFiles: 100,
        };
    },

    methods: {
        uploadExternalContent(ec) {
            this.$emit('ExternalContent', ec);
        },

        openDialog() {
            this.dialogTrigger++;
        },

        handleFileDrop(file) {
            if (this.editable) {
                this.uploadFile = file;
            }
        },

        clickFileInput() {
            const elem = this.$refs.fileinput.$refs.input
            elem.click()
        },

        createFiles(file) {
            const reader = new FileReader();
            //console.log('File', file);

            reader.onload = e => {
                this.localfilesrc = e.target.result;
            };
            var output;
            if (Array.isArray(file)) {
                output = [];
                for (var i = 0; i < file.length; i++) {
                    reader.readAsDataURL(file[i]);
                    output.push(reader.result);
                }
            }
            else {
                output = reader.readAsDataURL(file);
            }
        },

        onFileChange(file) {
            //console.log('onFileChange', file);
            this.$emit('File', file);
        },

        isSelected(file) {
            if (!this.selectedKeys) return false;
            const key = `${this.entityName}:${file.TypeId}:${file.Id}:${file.IsExternalContent ? 1 : 0}`;
            return this.selectedKeys.has(key);
        },
    },

    computed: {},

    watch: {
        uploadFile: function (val) {
            this.onFileChange(val);
        },
    },
};
</script>


<style lang='scss'></style>